import { Sample } from '@app/modules/service-data/types/sample.types';
import { Timestamp } from '@app/modules/service-data/types/service-data.types';
import { Kit, Product, ProductInventory } from '@core/core.types';

export interface LaboratoryBatch {
  id: string;
  laboratory: string;
  status: LaboratoryBatchStatus;
  samples: LaboratoryBatchSample[];
  dismissedSamples: LaboratoryBatchSample[];
  generated: Timestamp;
  sorted: Timestamp;
  finished: Timestamp;
}

export interface LaboratoryBatchAction {
  id: string;
  kitId: string;
  type: LaboratoryBatchActionTypes;
  timestamp: Date;
  batchStatus: LaboratoryBatchStatus;
  value?: string;
  batchId: string;
  synced: boolean;
  deleted: boolean;
}

export interface LaboratoryBatchSample {
  id: string;
  kitId: string;
  position: number;
  tags: string[];
  removed?: boolean;
  activeLaboratoryCodes?: string[];
  cancelledLaboratoryCodes?: string[];
}

export interface LaboratoryKitInfo {
  sample: Sample;
  kit: Kit;
  piis: [ProductInventory, Product][];
  product: Product;
  kitId: string;
  batchSample?: LaboratoryBatchSample;
  add?: boolean;
}

export enum LaboratoryBatchStatus {
  GENERATED = 'Generated',
  SORTED = 'Sorted',
  FINISHED = 'Finished',
}

export enum LaboratoryBatchActionTypes {
  ADDSAMPLE = 'add_sample',
  REMOVESAMPLE = 'remove_sample',
  ADDTAG = 'add_tag',
  REMOVETAG = 'remove_tag',
}

export enum LaboratoryBatchItemConsentTag {
  ConsentMissing = 'ConsentMissing',
  DoctorSignatureMissing = 'DoctorSignatureMissing',
  PatientSignatureMissing = 'PatientSignatureMissing',
}

export const Priority = 'Priority';
export const AddonsOnly = 'AddonsOnly';
export const NotInApp = 'NotInApp';
export const DSV120to125h = 'DSV120to125h';

export enum LaboratoryBatchItemDismissedTag {
  Over120h = 'Over120h',
  NotInApp = 'NotInApp',
  ExpiredTube = 'ExpiredTube',
  Hemolysis = 'Hemolysis',
  DamagedTube = 'DamagedTube',
  BloodClot = 'BloodClot',
  InsufficientVolume = 'InsufficientVolume',
  KitMixUp = 'KitMixUp',
  TestLimitation = 'TestLimitation',
  LabMistake = 'LabMistake',
  DHL = 'DHL',
  Ignore = 'Ignore',
  Other = 'Other',
}

export enum LaboratoryBatchItemDataRevisionTag {
  PackageChange = 'PackageChange',
  BarcodeCorrection = 'BarcodeCorrection',
  PatientDataUpdate = 'PatientDataUpdate',
  DOVCorrection = 'DOVCorrection',
  DSV120to125h = 'DSV120to125h',
  MedicalReviewRequest = 'MedicalReviewRequest',
}

export enum LaboratoryBatchItemReportRevisionTag {
  InvalidReport = 'InvalidReport',
}
